<template>
  <div ref="uploadRef">
    <div
      v-if="fileList.length < maxFile"
      tabindex="0"
      class="multiple-types-upload-file"
      @click.prevent
      @dragover="handleDragover"
      @drop="handleDrop"
      @paste="handlePaste"
    >
      <div class="upload-content">
        <a-icon type="plus" />
        <p class="ant-upload-text">
          {{ $t("basicUpload.uploadRemarkText") }}
          <a-upload
            ref="uploadRef"
            :multiple="true"
            :customRequest="handleCustomRequest"
            :file-list="[]"
          >
            <span style="color: #1890ff; cursor: pointer">
              {{ $t("basicUpload.localFiles") }}</span
            >
          </a-upload>
        </p>
        <p class="ant-upload-text">{{ $t("basicUpload.uploadFileTypeRemark") }}</p>
      </div>
    </div>
    <a-upload
      style="margin-top: 10px"
      :file-list="fileList"
      :remove="handleRemove"
      @preview="handlePreview"
      list-type="picture-card"
    >
    </a-upload>
  </div>
</template>
<script>
const addedListeners = new WeakSet();
// import uploadIcon from "./icon/upload.png";
export default {
  name: "base-upload",
  props: ["fileList", "maxFile"],
  data() {
    return {};
  },

  methods: {
    async handleCustomRequest({ file }) {
      console.log("handleCustomRequest");
      this.uploadFile(file);
    },

    handleRemove(file) {
      this.$emit("remove", file);
    },
    handlePreview(file) {
      this.$emit("preview", file);
    },
    addListenerIfNotPresent(element, eventName, listener) {
      if (!addedListeners.has(listener)) {
        element.addEventListener(eventName, listener);
        addedListeners.add(listener);
      }
    },
    handleBlur() {
      console.log("blur");
    },
    async handlePaste(event) {
      const items = event.clipboardData?.items;
      if (items) {
        for (let i = 0; i < items.length; i++) {
          const item = items[i];
          if (item.kind === "file") {
            const file = item.getAsFile();
            this.uploadFile(file);
          }
        }
      }
    },
    async uploadFile(file) {
      const maxSize = 1024 * 1024 * 30;
      if (file.type.indexOf("image") < 0) {
        this.$message.warning(this.$t("basicUpload.fileTypeMessage"));
        return false;
      }
      if (file.size > maxSize) {
        this.$message.warning(this.$t("basicUpload.maxSizeMessage"));
        return false;
      }
      const fileKey = "id-" + Math.random().toString(36).substr(2, 9);
      const SelectFileInfo = {
        fileKey: fileKey,
        fileName: file.name,
        file: file,
      };
      this.$emit("change", SelectFileInfo);
    },
    handleDragover(e) {
      e.preventDefault();
    },
    handleDrop(e) {
      e.preventDefault();
      // 获取拖放的文件列表
      const { files } = e.dataTransfer;
      if (files && files.length) {
        for (const item of files) {
          this.uploadFile(item);
        }
      }
    },
    handleFocus() {
      // this.$refs.uploadRef.focus();
      console.log("focus");
    },
  },
};
</script>
<style scoped>
.multiple-types-upload-file {
  position: relative;
  justify-content: center;
  align-items: center;
  background: #fafafa;
  border: 1px dashed #d9d9d9;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 18px;
}
/* .multiple-types-upload-file:hover {
  border: 1px dashed #1890ff;
} */
.multiple-types-upload-file:focus {
  /* border: 1px dashed #1890ff; */
  border: 1px dashed #1890ff;
}
.multiple-types-upload-file .upload-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.multiple-types-upload-file .ant-upload-text {
  padding: 0px 18px;
  margin: 0px;
  font-size: 13px;
  line-height: 1.5;
}

.multiple-types-upload-file .upload-content .ant-upload-drag-icon {
  margin-bottom: 12px;
}

.multiple-types-upload-file .upload-content .ant-upload-drag-icon > img {
  position: relative;
  width: 60px;
}
</style>
